import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const BbxStepper02Icon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M20.25 3.75L23 5L20.25 6.25L19 9L17.75 6.25L15 5L17.75 3.75L19 1L20.25 3.75ZM20.25 17.75L23 19L20.25 20.25L19 23L17.75 20.25L15 19L17.75 17.75L19 15L20.25 17.75Z"
            fill="#222"
          />
          <path
            d="M8.99998 20.4C13.6392 20.4 17.4 16.6392 17.4 12C17.4 7.36081 13.6392 3.6 8.99998 3.6C4.36078 3.6 0.599976 7.36081 0.599976 12C0.599976 16.6392 4.36078 20.4 8.99998 20.4ZM6.01198 15.084V16.2H11.796V14.94H8.15998C8.53598 14.636 8.92398 14.308 9.32398 13.956C9.72398 13.596 10.096 13.212 10.44 12.804C10.784 12.396 11.06 11.972 11.268 11.532C11.484 11.092 11.592 10.64 11.592 10.176C11.592 9.432 11.352 8.828 10.872 8.364C10.4 7.892 9.73598 7.656 8.87998 7.656C8.35198 7.656 7.87598 7.76 7.45198 7.968C7.02798 8.168 6.68798 8.476 6.43198 8.892C6.17598 9.3 6.03998 9.812 6.02398 10.428H7.51198C7.51198 10.02 7.62398 9.672 7.84798 9.384C8.07198 9.096 8.40398 8.952 8.84398 8.952C9.27598 8.952 9.58398 9.084 9.76798 9.348C9.95998 9.612 10.056 9.916 10.056 10.26C10.056 10.628 9.93998 11.008 9.70798 11.4C9.48398 11.784 9.17998 12.18 8.79598 12.588C8.41998 12.996 7.98798 13.408 7.49998 13.824C7.01998 14.24 6.52398 14.66 6.01198 15.084Z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
        </svg>
      </IconWrapper>
    )
  },
)
